import { z } from 'zod';

export const ONUS_STATUS = ['vigente', 'vencido_sem_baixa', 'baixado'] as const;
export const onusStatusSchema = z.enum(ONUS_STATUS);
export type OnusStatus = z.infer<typeof onusStatusSchema>;

export const ONUS_STATUS_LABEL: Record<OnusStatus, string> = {
  vigente: 'Vigente',
  vencido_sem_baixa: 'Vencido / passível de baixa',
  baixado: 'Baixado',
};

export const onusAtoSchema = z.object({
  data: z.string().nullish(),
  descricao: z.string().min(1),
});
export type OnusAto = z.infer<typeof onusAtoSchema>;

export const onusItemSchema = z.object({
  id: z.string().min(1),
  credor: z.string().default(''),
  tipo: z.string().default(''),
  instrumento: z.string().default(''),
  cedula: z.string().nullish(),
  valor: z.number().nullish(),
  grau: z.string().nullish(),
  ato_registral: z.string().default(''),
  ato: z.string().nullish(),
  data_registro: z.string().nullish(),
  vencimento: z.string().nullish(),
  status: onusStatusSchema,
  status_source: z.enum(['auto', 'manual']),
  atos: z.array(onusAtoSchema).default([]),
  observacoes: z.string().default(''),
  origem_documento: z.string().nullish(),
  migrated_from_text: z.boolean().optional(),
  created_at: z.string().nullish(),
  updated_at: z.string().nullish(),
});
export type OnusItem = z.infer<typeof onusItemSchema>;

export const onusItemsSchema = z.array(onusItemSchema);

export function derivarStatusOnus(
  vencimento: string | null | undefined,
  today: Date = new Date(),
): OnusStatus {
  if (!vencimento) return 'vigente';
  const v = new Date(vencimento);
  if (Number.isNaN(v.getTime())) return 'vigente';
  v.setHours(0, 0, 0, 0);
  const t = new Date(today);
  t.setHours(0, 0, 0, 0);
  return v < t ? 'vencido_sem_baixa' : 'vigente';
}

export function novoOnusItem(overrides: Partial<OnusItem> = {}): OnusItem {
  const now = new Date().toISOString();
  const status = overrides.status ?? derivarStatusOnus(overrides.vencimento ?? null);
  return {
    id:
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : `onus-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    credor: '',
    tipo: '',
    instrumento: '',
    ato_registral: '',
    data_registro: null,
    vencimento: null,
    status,
    status_source: 'auto',
    atos: [],
    observacoes: '',
    created_at: now,
    updated_at: now,
    ...overrides,
  };
}

export function parseOnusItems(value: unknown): OnusItem[] {
  if (Array.isArray(value)) {
    const parsed = onusItemsSchema.safeParse(value);
    if (parsed.success) return parsed.data;
  }
  return [];
}
